import { message } from 'antd';
import DatePicker from 'components/DateTimePicker/DatePicker';
import SearchAirport from 'components/public/SearchAirport';
import dayjs from 'untils/dateTime/day';

import { motion } from 'framer-motion/dist/framer-motion';
import { vw } from 'pages/affiliatePartner/AffiliatePartner.style';
import React, { useEffect, useReducer, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { getSessionStorage, roll, setSessionStorage } from 'untils/auth';
import { roundToNearestTime } from 'untils/dateTime';
import { flexGap } from 'untils/polyfill/flex';
import { Section } from '../Home.style';
import StickyNav from './StickyNav';
import * as StyledComponent from './UserRequest.style';

const initForm = {
  inputClass: ['', '', '', ''],
  fromValue: '', //去程机场
  toValue: '', //去程机场
  currentDate: '', // 默认日期
  currentFocusInput: '',
  inputRules: {
    fromCity: false, // 出发地
    toCity: false, // 目的地
    fromDate: false, // 去程日期
  },
  dateShow: false, //单程日期显示
  monthOnDisplay: dayjs(),
};

const formReducer = (state, action) => {
  let newState;
  switch (action.type) {
    case 'SetFormValue': {
      newState = { ...state, ...action.payload };
      break;
    }
    case 'Reset': {
      return initForm;
    }
    default:
      throw new Error();
  }
  return newState;
};

const RequestInputContainer = styled(Section)`
  // 智能搜索
  line-height: normal;

  z-index: 9;
  margin: 0;
  width: calc(100% - (var(--home-inline-padding) * 2));
  max-width: 1300px;
  background: rgba(191, 202, 240, 0.4);
  backdrop-filter: blur(6px);
  border-radius: 16px;
  padding: ${vw(8)};
  .white-swap {
    display: grid;
    place-items: center;
    align-self: flex-end;
    cursor: pointer;
  }

  @media (max-width: 938px) {
    padding: 8px;
    bottom: 40rem;
    top: unset;
  }

  display: ${(props) => (props.$show ? '' : 'none')};
`;

const RequestContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${flexGap('16px')}
  padding: ${vw(16)};

  position: relative;
  background-color: #fff;
  border-radius: 8px;

  .search-results {
    position: relative;
  }
  .search-results > .search-airport {
    flex: 1;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 8px;

    .icon-text > img {
      position: absolute;
      width: ${vw(40)};
      height: ${vw(40)};
    }

    input {
      display: flex;
      align-items: center;
      border-radius: 8px;
      font-size: ${vw(20)};
      font-weight: 400;
      z-index: 2;
    }
    input::placeholder {
      font-weight: 400;
      color: rgba(13, 17, 35, 0.48);
    }

    .ant-input {
      background-color: transparent;

      &:focus {
        border: ${vw(2)} solid transparent;
        box-shadow: none;
      }
    }
  }

  @media (max-width: 938px) {
    padding: 0;

    align-items: flex-start;
    flex-direction: column;
    background-color: transparent;
  }

  @media (max-width: 757px) {
    .search-results > .search-airport {
      .icon-text > img {
        width: ${vw(24)};
        height: ${vw(24)};
      }
    }
  }
`;

const DateTimeContainer = styled.div`
  position: relative;
  width: 100%;
  .ant-picker-dropdown {
    top: ${vw(80)} !important;
    left: ${vw(-9)} !important;
  }
  .user-date-time {
    display: flex;
    background: #fff;
    border-radius: ${vw(8)};
    position: relative;
    align-items: center;

    & > img {
      width: 40px;
      height: 40px;
    }
    input {
      font-size: ${vw(18)};
    }
    input::placeholder {
      font-weight: 400;
      color: rgba(13, 17, 35, 0.48);
    }

    &:hover {
      input::placeholder {
        color: #07080a;
      }
    }

    @media (max-width: 938px) {
      padding: 8px 16px;
    }
    @media (max-width: 757px) {
      & > img {
        width: 24px;
        height: 24px;
      }
    }
  }
`;

const QuoteButton = styled(motion.button)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1.1 auto;

  padding: 8px 16px;
  width: 100%;
  gap: 8px;

  background-color: #0063db;
  border-radius: 8px;

  border-radius: ${vw(8)};
  font-size: ${vw(18)};
  font-weight: 700;
  color: #fff;

  i {
    width: ${vw(40)};
    height: ${vw(40)};
    background-image: url('/imgs/svg/seach.svg');
  }
`;

const showInputTypes = {
  default: '',
  normal: 'normal',
  origin: 'origin',
  destination: 'destination',
};

const RequestInput = () => {
  const [state, dispatch] = useReducer(formReducer, initForm);

  const history = useHistory();
  const originRef = useRef();
  const dateRef = useRef();
  const destinationRef = useRef();
  const stickyNavRef = useRef();

  const [showInput, setShowInput] = useState(showInputTypes.default);
  const [dateHover, setDateHover] = useState(false);

  const {
    inputClass,
    fromValue, //去程机场
    toValue, //去程机场
    currentDate,
    currentFocusInput,
    inputRules,
    dateShow,
    monthOnDisplay,
  } = state;

  // 自动聚焦 子传父
  const getfocus = (value) => {
    if (value === 'to') {
      dateRef.current.focus();
      dispatch({
        type: 'SetFormValue',
        payload: {
          dateShow: true,
        },
      });
    }
  };

  //互换出发地目的地
  const reverse = () => {
    let { fromValue, toValue } = state;

    let flyLocationForm = getSessionStorage('flyLocationForm') || {};
    let flyLocationTo = getSessionStorage('flyLocationTo') || {};
    if (flyLocationForm.length) flyLocationForm = JSON.parse(flyLocationForm);
    if (flyLocationTo.length) flyLocationTo = JSON.parse(flyLocationTo);

    setSessionStorage('flyLocationForm', JSON.stringify(flyLocationTo));
    setSessionStorage('flyLocationTo', JSON.stringify(flyLocationForm));

    setSessionStorage('from', JSON.stringify(toValue));
    setSessionStorage('to', JSON.stringify(fromValue));

    dispatch({ type: 'SetFormValue', payload: { fromValue: toValue, toValue: fromValue } });

    originRef.current.getCacheData(); //调用出发子组件的dream方法 这个不是dream方法 这是看了血压飙升的方法
    destinationRef.current.getCacheData(); //调用出发子组件的dream方法 这个不是dream方法 这是看了血压飙升的方法
  };

  // 包机填写校验
  const checkValue = () => {
    message.destroy();
    let { fromValue, toValue, currentDate } = state;
    // 未填写, 提示弹窗信息并且置亮input
    if (!fromValue.id && !toValue.id && !currentDate) {
      dispatch({
        type: 'SetFormValue',
        payload: {
          inputRules: {
            fromCity: true, // 出发地
            toCity: true, // 目的地
            fromDate: true, // 去程日期
          },
        },
      });

      return message.warning('Please enter your information!');
    }

    // 仅一项未填提示弹窗信息并且置亮input
    if (!fromValue.id) {
      dispatch({
        type: 'SetFormValue',
        payload: {
          inputRules: {
            fromDate: false, // 去程日期
            toCity: false, // 目的地
            fromCity: true,
          },
        },
      });
      return message.warning('Please enter the place of departure');
    }
    if (!toValue.id) {
      dispatch({
        type: 'SetFormValue',
        payload: {
          inputRules: {
            fromDate: false, // 去程日期
            toCity: true, // 目的地
            fromCity: false,
          },
        },
      });
      return message.warning('Please enter the destination place');
    }

    if (!currentDate) {
      dispatch({
        type: 'SetFormValue',
        payload: {
          inputRules: {
            fromDate: true, // 去程日期
            toCity: false, // 目的地
            fromCity: false,
          },
        },
      });
      return message.warning('Please enter the date');
    }
    dispatch({
      type: 'SetFormValue',
      payload: {
        inputRules: {
          fromCity: false, // 出发地
          toCity: false, // 目的地
          fromDate: false, // 去程日期
        },
      },
    });
    if (fromValue.id === toValue.id) {
      return message.error('The departure city and destination city cannot be the same!');
    }
  };

  // 跳转到包机页面
  const openCharterQuote = () => {
    let { fromValue, toValue, currentDate } = state;
    //校验
    checkValue();

    if (Object.keys(fromValue).length && Object.keys(toValue).length && currentDate) {
      const timeZone = fromValue.timezone ? fromValue.timezone : dayjs.tz.guess();
      const currentDay = dayjs(currentDate).isSame(
        dayjs().tz(timeZone).format('YYYY-MM-DD'),
        'day'
      );
      let localeTime = dayjs().tz(timeZone);
      setSessionStorage(
        'userFormData',
        JSON.stringify({
          dateStart: currentDate.format('MMM DD, YYYY'),
          timeStart: currentDay
            ? roundToNearestTime(localeTime, 'minutes', 30).add(1, 'hour').format('HH:mm')
            : '09:00',
          passenger: 1,
          type: 0,
        })
      );

      history.push('/charterQuote');
    }
  };

  // 获取机场地址（子传父）
  const getAddress = (type, name) => {
    dispatch({
      type: 'SetFormValue',
      payload: {
        [type === 'from' ? 'fromValue' : 'toValue']: name,
      },
    });
  };

  // 获取日期
  const changeDate = (_, e) => {
    let inputClass = state.inputClass;
    inputClass[2] = 'input-active-goTime';

    dispatch({
      type: 'SetFormValue',
      payload: {
        currentDate: dayjs(e, 'MMM DD, YYYY'),
        time: null, // 单程时间
        inputClass,
        dateShow: false,
      },
    });
  };

  //点击表单滚动到屏幕中间
  const scrollUpHandle = () => {
    roll(400);
  };

  //input框的有内容时置灰
  const priceQuoteInput = (e, index, name) => {
    let value = index === 0 || index === 1 ? e : e.target.value;
    let inputClass = state.inputClass;
    if (value.length > 0) {
      inputClass[index] = `input-active-${name}`;
    } else {
      inputClass[index] = '';
    }
    dispatch({
      type: 'SetFormValue',
      payload: {
        inputClass,
      },
    });
  };

  //更新出发地&目的地聚焦
  const updateInputFocus = (type) => {
    dispatch({
      type: 'SetFormValue',
      payload: {
        currentFocusInput: type,
      },
    });
  };

  //更新出发地&目的地校验
  const updateInputRules = (type) => {
    let { inputRules } = state;
    //更新出发地、目的地校验
    if (type === 'from') {
      inputRules.fromCity = false;
    } else {
      inputRules.toCity = false;
    }
    dispatch({
      type: 'SetFormValue',
      payload: {
        inputRules,
      },
    });
  };

  useEffect(() => {
    if (showInput === showInputTypes.origin) {
      originRef.current?.info?.current?.focus();
    } else if (showInput === showInputTypes.destination) {
      destinationRef.current?.info?.current?.focus();
    }
  }, [showInput]);

  return (
    <>
      <RequestInputContainer $show={!!showInput}>
        <RequestContainer>
          <StyledComponent.LocationContainer>
            <SearchAirport
              stickyNavRef={stickyNavRef}
              type="from"
              page="home"
              dataValue={fromValue}
              resultSstyle="results-style"
              getAddress={getAddress}
              priceQuoteInput={priceQuoteInput}
              inputClass={inputClass}
              scrollUpHandle={scrollUpHandle}
              currentFocusInput={currentFocusInput}
              inputRules={inputRules}
              onRef={(c) => (originRef.current = c)}
              updateInputFocus={updateInputFocus}
              updateInputRules={updateInputRules}
              clear={true}
              getfocus={getfocus}
            />
            <motion.button
              className="white-swap"
              whileHover={{
                scale: 1.2,
                transition: { duration: 1 },
              }}
              whileTap={{ scale: 0.9 }}
              onClick={reverse}
            >
              <StyledComponent.InputIcon $src="imgs/svg/reverse.svg" />
            </motion.button>
            <SearchAirport
              stickyNavRef={stickyNavRef}
              type="to"
              page="home"
              dataValue={toValue}
              resultSstyle="results-style"
              getAddress={getAddress}
              priceQuoteInput={priceQuoteInput}
              inputClass={inputClass}
              scrollUpHandle={scrollUpHandle}
              currentFocusInput={currentFocusInput}
              inputRules={inputRules}
              onRef={(c) => (destinationRef.current = c)}
              updateInputFocus={updateInputFocus}
              updateInputRules={updateInputRules}
              clear={true}
              getfocus={getfocus}
            />
          </StyledComponent.LocationContainer>

          <DateTimeContainer>
            <div
              className={`user-date-time  ${inputRules.fromDate ? 'error' : ''}`}
              onMouseEnter={() => setDateHover(true)}
              onMouseLeave={() => setDateHover(false)}
            >
              <img src={`/imgs/svg/${dateHover ? 'date.svg' : 'date-grey.svg'}`} alt="date icon" />
              <DatePicker
                ref={dateRef}
                id="picker"
                format={'MMM DD, YYYY'}
                disabledDate={(current) => {
                  const timeZone = fromValue.timezone ? fromValue.timezone : dayjs.tz.guess();
                  return current.isBefore(dayjs().tz(timeZone).format('YYYY-MM-DD', 'day'));
                }}
                placeholder={`Date`}
                allowClear={false}
                bordered={false}
                // suffixIcon={null}
                value={currentDate}
                onChange={changeDate}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                dateRender={(current) => {
                  if (!current.isSame(dayjs(monthOnDisplay).format(`YYYY-MM-DD`), 'month')) {
                    return null;
                  }
                  return <div className="ant-picker-cell-inner">{current.date()}</div>;
                }}
                onFocus={() => {
                  dispatch({
                    type: 'SetFormValue',
                    payload: {
                      dateShow: true,
                    },
                  });
                }}
                onPanelChange={(current) => {
                  dispatch({
                    type: 'SetFormValue',
                    payload: {
                      monthOnDisplay: current,
                    },
                  });
                }}
                onBlur={() => {
                  dispatch({
                    type: 'SetFormValue',
                    payload: {
                      dateShow: false,
                    },
                  });
                }}
                open={dateShow}
              />
            </div>
          </DateTimeContainer>

          <QuoteButton
            whileHover={{
              backgroundColor: 'rgba(0, 99, 219, .8)',
              scale: 1.03,
              transition: { duration: 0.35, ease: 'linear' },
            }}
            onClick={openCharterQuote}
          >
            Search
            <i className="bg-image" />
          </QuoteButton>
        </RequestContainer>
      </RequestInputContainer>

      <StickyNav
        ref={stickyNavRef}
        handleActionA={() => {
          setShowInput(showInputTypes.origin);
        }}
        handleActionB={() => {
          setShowInput(showInputTypes.destination);
        }}
        setShowInput={(showType) => {
          setShowInput(showType);
        }}
        showInput={showInput}
        showInputTypes={showInputTypes}
      />
    </>
  );
};

export default RequestInput;
